<template>
  <p class="font-weight-normal pl-0 mt-2">
    <span v-if="!readMore">
      {{ text | truncate(constant.DESCRIPTION_LENGTH) }}
    </span>
    <span v-else>{{ text }} </span>
    <a
      v-if="text.length > constant.DESCRIPTION_LENGTH"
      role="button"
      @click="$emit('readMoreClick', !readMore)"
      class="ot-priamry cursor-pointer"
      >Read {{ readMore ? "Less" : "More" }}
    </a>
  </p>
</template>
<script>
import Constant from "@/constants/config/Constant";
export default {
  props: {
    text: {
      type: String,
      required: true,
      default: () => "",
    },
    readMore: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {
      constant: Constant,
    };
  },
};
</script>
